import { cloneDeep, concat, get, isEmpty } from 'lodash';
import type from './DAM.type';
import { Page_Size } from '../../../Components/helper';

const initialState = {
  damList: [],
  totalCount: 0,
  damProductList: [],
  damTagList: [],
  damEditData: null,
  damArhivedlist: [],
  totalAcrhivedCount: 0,
  totalDeletedCount: 0,
  damDeletedFiles: [],
  filterValues: {
    colorTheme: [],
    primaryColour: [],
    secondaryColour: [],
    folder: [],
    fileType: [],
    assetType: [],
    productType: [],
    brand: [],
    gradingGroups: [],
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    dynamicDropdown: [],
    pageIndex: 1,
    pageSize: Page_Size,
    tags: [],
  },
};

const DamReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DAM_LIST:
      const updatedDamArry = cloneDeep(setArrayByCase(state.damList, action.payload));
      return {
        ...state,
        damList: updatedDamArry,
        totalCount: action?.payload?.totalCount,
      };
    case type.DAM_ALL_PRODUCT_LIST:
      return {
        ...state,
        damProductList: action?.payload,
      };
    case type.DAM_TAGS_LIST:
      return {
        ...state,
        damTagList: action?.payload,
      };
    case type.DAM_EDIT_DATA:
      return {
        ...state,
        damEditData: action?.payload,
      };
    case type.SET_ARCHIVED_FILES_FOLDERS:
      const updatedArchivedArry = cloneDeep(setArrayByCase(state.damArhivedlist, action.payload));
      return {
        ...state,
        damArhivedlist: updatedArchivedArry,
        totalAcrhivedCount: action?.payload?.totalCount,
      };
    case type.DAM_CLEAR_REDUCER:
      return {
        ...state,
        damEditData: null,
      };
    case type.DAM_SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case type.SET_DELETED_FILES:
      const updatedDeletedArry = cloneDeep(setArrayByCase(state.damDeletedFiles, action.payload));
      return {
        ...state,
        damDeletedFiles: updatedDeletedArry,
        totalDeletedCount: action?.payload?.totalCount,
      };
    case type.DAM_ALL_FOLDER_LIST:
      return {
        ...state,
        allDamFolderList: action.payload,
      };

    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

export default DamReducer;
